import {
  LinkedGroup,
  UpdateLinkedGroupsParams,
} from '@/domain/models/LinkItem';
import { DASHBOARD_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
// import { fetchLinkedGroups } from '@/mocks/menu/linkItem';

interface Interface {
  fetch: () => Promise<{ groups: LinkedGroup[] }>;
  put: (params: UpdateLinkedGroupsParams) => Promise<void>;
}

export class LinkedGroupService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async fetch(): Promise<{ groups: LinkedGroup[] }> {
    return await this.restClient.get<{ groups: LinkedGroup[] }>(
      `${DASHBOARD_API_ORIGIN}/api/menus/sales-state-items/groups` as const
    );
    // NOTE api schema のデータは件数が少ないため、件数を増やして検証をするときは restClientをコメントアウトして下記を使用してください。
    // return fetchLinkedGroups;
  }

  public async put(params: UpdateLinkedGroupsParams): Promise<void> {
    await this.restClient.put<UpdateLinkedGroupsParams, void>(
      `${DASHBOARD_API_ORIGIN}/api/menus/sales-state-items/groups` as const,
      params
    );
  }
}
